import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../../../utils/withDefaults';
export const Form = styled('form')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: theme.spacing(2.5),
  flex: 1
}));
const GridItemRoot = styled(Grid)({});
export const GridItem = withDefaults(GridItemRoot, {
  size: {
    xs: 12
  }
});
export const LastGridItem = styled(GridItem)(({
  theme
}) => ({
  paddingTop: theme.spacing(1) + '!important'
}));